// extracted by mini-css-extract-plugin
export default {"mainTag":"tags_mainTag__QMD9y","other-capitalized-caption":"tags_other-capitalized-caption__5qLmC"};